var _Text;
import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { Button, ButtonToolbar, DisclaimerText, Image, Link, Text } from 'reaxl';
import { footer } from 'axl-config';
import NonstaticSitemap from '../NonstaticSitemap';
import NonstaticFooterLegal from '../NonstaticFooterLegal';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  sitemap,
  social,
  appStore
} = footer;
const renderSocialButton = _ref => {
  let {
    alt,
    src,
    imgHeight,
    imgWidth,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx(Button, {
    bsStyle: "link",
    target: "_blank",
    ...rest,
    children: /*#__PURE__*/_jsx(Image, {
      src: src,
      alt: "",
      "aria-hidden": "true",
      lazyload: true,
      height: imgHeight,
      width: imgWidth
    })
  }, rest.href);
};
const renderSocial = data => /*#__PURE__*/_jsxs(ButtonToolbar, {
  className: "margin-horizontal-2",
  children: [_Text || (_Text = /*#__PURE__*/_jsx(Text, {
    className: "label text-bold text-inverse",
    children: "Follow"
  })), data.map(renderSocialButton)]
});
const renderLegal = (footerLegal, renderThirdParty) => footerLegal || /*#__PURE__*/_jsx(NonstaticFooterLegal, {
  renderThirdParty: renderThirdParty
});
function NonstaticFooter(_ref2) {
  let {
    barContent,
    size = 'lg',
    sitemap: footerSitemap = sitemap,
    social: footerSocial = social,
    appStore: footerAppStore = appStore,
    legal: footerLegal,
    renderThirdParty = true,
    className,
    onClick,
    ...rest
  } = _ref2;
  return /*#__PURE__*/_jsxs("footer", {
    "data-cmp": "footer",
    className: clsx('footer', className),
    ...rest,
    children: [/*#__PURE__*/_jsx("div", {
      className: "container-fluid",
      children: /*#__PURE__*/_jsx("div", {
        className: "container",
        children: /*#__PURE__*/_jsx("div", {
          className: "row",
          children: /*#__PURE__*/_jsx("div", {
            className: "col-xs-12",
            children: barContent
          })
        })
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "container-fluid",
      children: /*#__PURE__*/_jsxs("div", {
        className: "container",
        children: [footerSitemap && /*#__PURE__*/_jsx(NonstaticSitemap, {
          data: footerSitemap,
          collapsed: ['xs', 'sm'].includes(size)
        }), /*#__PURE__*/_jsx("div", {
          className: "app-store-bar margin-vertical-5",
          children: footerAppStore.map((icon, index) => /*#__PURE__*/_jsxs(Link, {
            href: icon.href,
            target: "_blank",
            rel: "nofollow noopener",
            onClick: e => {
              const data = {
                appStoreName: icon.gaAppStoreName
              };
              onClick(e, data);
            },
            children: [/*#__PURE__*/_jsx("span", {
              className: "sr-only",
              children: icon['aria-label']
            }), /*#__PURE__*/_jsx(Image, {
              className: index === 1 ? 'margin-left-4' : '',
              src: icon.src,
              alt: "",
              "aria-hidden": "true",
              lazyload: true,
              height: icon.imgHeight,
              width: icon.imgWidth
            })]
          }, index))
        }), /*#__PURE__*/_jsx("div", {
          className: "icon-bar margin-vertical-5",
          children: footerSocial && renderSocial(footerSocial)
        }), /*#__PURE__*/_jsx(DisclaimerText, {
          className: "margin-vertical-5 text-center",
          inverse: true,
          children: renderLegal(footerLegal, renderThirdParty)
        })]
      })
    })]
  });
}
export default NonstaticFooter;